import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { breadcrumbSchema, organizationSchema, websiteSchema } from "../../utils/structuredData";
import Header from "../HeaderSection/Header";
import Breadcrumb from "./Breadcrumb";
import Blog from "./Blog";
import FooterSection from "../FooterSection/FooterTwo";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import BottomBar from "../BottomBar/BottomBar";

class BlogTwoColumn extends Component {
  render() {
    return (
      <section id="blog" className="main">
        <Helmet>
          <title>Blog | MoneyMonk - Personal Finance &amp; Loan Tips</title>
          <meta name="description" content="Read the latest articles on personal loans, money management, and financial tips from MoneyMonk — India's trusted digital lending platform." />
          <link rel="canonical" href="https://moneymonkapp.in/blog" />
          <script type="application/ld+json">{JSON.stringify(breadcrumbSchema([
            { name: 'Home', url: 'https://moneymonkapp.in' },
            { name: 'Blog', url: 'https://moneymonkapp.in/blog' }
          ]))}</script>
          <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
          <script type="application/ld+json">{JSON.stringify(websiteSchema())}</script>
        </Helmet>
        <Navbar imageData={logo} />
        <div className="container" style={{paddingTop: "100px"}}>
          <Blog />
           
        </div>
       <BottomBar/>
      </section>
    );
  }
}

export default BlogTwoColumn;
